import * as React from "react";
import Flickity from "react-flickity-component";
import { FiArrowRight } from "react-icons/fi";
import { PasarCarouselWrapper } from "./Styled";
// import { Link } from "react-router-dom";
import Link from "../Util/Link";

class PasarCarousel extends React.Component {
  render() {
    const { title, page, mainColor, subColor } = this.props;
    const pageLength = page.length;
    if (pageLength === 0) return null;
    return (
      <PasarCarouselWrapper
        pageLength={pageLength}
        mainColor={mainColor}
        subColor={subColor}
      >
        <div className="wrapper">
          <h1 className="title">{title}</h1>
        </div>
        <div className="banner-wrapper">
          <Flickity
            className="flickity" // default ''
            elementType="div" // default 'div'
            options={{
              initialIndex: 0,
              contain: true,
              cellAlign: "left"
            }} // takes flickity options {}
            disableImagesLoaded={false} // default false
            reloadOnUpdate // default false
            static // default false
          >
            {page.map((item, index) => {
              const {
                title,
                name,
                short_description,
                tile_description,
                image_arr,
                slug
              } = item;
              const image = image_arr && image_arr[0];

              return (
                <Link
                  to={`/pasar/${slug}`}
                  className="banner-item"
                  key={`${index}-highlight`}
                >
                  <div
                    className="banner-image"
                    style={{ backgroundImage: `url(${image})` }}
                  />
                  <div className="banner-title">
                    {/* <h3 className="sub-title">Sub Title</h3> */}
                    <h1
                      className="title"
                      dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <p
                      className="content"
                      dangerouslySetInnerHTML={{ __html: tile_description }}
                    />
                  </div>
                </Link>
              );
            })}
          </Flickity>
        </div>
      </PasarCarouselWrapper>
    );
  }
}

export default PasarCarousel;
